export default {
  app: {
    languagePopup: {
      title: 'You are currently on the English version of {logo}',
      subtitle: 'Do you wish to switch to your preferred language?',
      cta: 'Switch to {lang}',
    },
  },
};
